import { BaseComponent, FontAwesomeComponent } from '@aeins/core';
import { Component } from '@angular/core';
import { IonApp, IonHeader, IonRouterOutlet, IonToolbar } from '@ionic/angular';
import { environment } from 'environments/environment';

@Component({
    imports: [IonApp, IonHeader, IonToolbar, IonRouterOutlet, FontAwesomeComponent],
    selector: 'aeins-root',
    templateUrl: 'app.html',
    styleUrls: ['app.css'],
})
export class AppComponent extends BaseComponent {
    instanceName = environment.label;
}
